import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminAuth, formatError } from "../api";
import { useAuth } from "../auth";
import { Button, Card, Input, PageHeader, Spinner } from "../ui";

export default function Account() {
  const { user, changePassword, refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [conf, setConf] = useState("");
  const [busy1, setBusy1] = useState(false);
  const [busy2, setBusy2] = useState(false);

  useEffect(() => {
    if (user) {
      setEmail(user.email || "");
      setName(user.name || "");
    }
  }, [user]);

  if (!user) return <Spinner />;

  const saveProfile = async (e) => {
    e.preventDefault();
    setBusy1(true);
    try {
      await adminAuth.patchMe({ email, name });
      await refresh();
      toast.success("Profile updated.");
    } catch (err) { toast.error(formatError(err)); }
    finally { setBusy1(false); }
  };

  const savePassword = async (e) => {
    e.preventDefault();
    if (nw !== conf) return toast.error("Passwords do not match");
    setBusy2(true);
    try {
      await changePassword(cur, nw);
      setCur(""); setNw(""); setConf("");
      toast.success("Password changed.");
    } catch (err) { toast.error(formatError(err)); }
    finally { setBusy2(false); }
  };

  return (
    <div data-testid="admin-account">
      <PageHeader title="Account" description="Manage your admin profile and password." />
      <div className="grid gap-6 max-w-3xl lg:grid-cols-2">
        <Card className="p-6">
          <h2 className="font-display text-lg font-semibold text-[hsl(var(--aoa-navy))] mb-4">Profile</h2>
          <form onSubmit={saveProfile} className="space-y-4">
            <Input label="Name" value={name} onChange={(e) => setName(e.target.value)} testId="account-name" />
            <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} testId="account-email" />
            <Button loading={busy1} testId="account-save-profile">Save profile</Button>
          </form>
        </Card>
        <Card className="p-6">
          <h2 className="font-display text-lg font-semibold text-[hsl(var(--aoa-navy))] mb-4">Password</h2>
          <form onSubmit={savePassword} className="space-y-4">
            <Input label="Current password" type="password" value={cur} onChange={(e) => setCur(e.target.value)} testId="account-cur" />
            <Input label="New password" type="password" value={nw} onChange={(e) => setNw(e.target.value)} hint="Min 10 chars, must include a letter and a number." testId="account-new" />
            <Input label="Confirm new password" type="password" value={conf} onChange={(e) => setConf(e.target.value)} testId="account-conf" />
            <Button loading={busy2} testId="account-save-password">Change password</Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
